import { notesEpic as epic } from "./epic";
import { noteReducer as reducer } from "./reducer";

export const notesEpic = epic
export const noteReducer = reducer
